import { useContext } from "react";
import { LoginContext } from "../Components/Login/LoginContext";
import {
  AppBar,
  Toolbar,
  useTheme,
  useMediaQuery,
  Box,
} from "@mui/material";
import logo from "../transparent-logo.png";
import NavigationDrawer from "./NavigationDrawer";
import NavigationBar from "./NavigationBar";
import BottomNav from "./BottomNav";

const Navigation = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [auth] = useContext(LoginContext);

  return (
    <nav>
      <AppBar sx={{ backgroundColor: "#1a2332" }}>
        <Toolbar>
          <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
            <img
              src={logo}
              alt="PCFA Logo"
              style={{ height: "40px", marginRight: "8px" }}
            />
          </Box>
          {isMobile ? (
            <NavigationDrawer showActions={auth.loggedIn}></NavigationDrawer>
          ) : (
            <NavigationBar showActions={auth.loggedIn}></NavigationBar>
          )}
        </Toolbar>
      </AppBar>
      {isMobile && <BottomNav />}
    </nav>
  );
};

export default Navigation;
